export class ClsCatalogosExpIns {
  IdCatalogo: bigint;
  IdCatalogoS?: string;
  Codigo: string;
  DescripcionLarga: string;
  Descripcion: string;
  Unidad: string;
  Tipo: number;
  CostoMoneda1: number;
  CostoMoneda2: number;
  Expins: number;
  ImporteMoneda1: number;
  ImporteMoneda2: number;
  IdFamilia?: bigint;
  Familia: string;
  DescripcionFamilia: string;
  Referencia: string;
  Marca: boolean;
  Nivel: number;
  ExpInsl: boolean;
  EsConceptosDelPpto: boolean;
  IdProveedor?: bigint;
  Proveedor: string;
  RazonSocial: string;
  InsumoIntegrado: boolean;
  FechaMoneda1: Date;
  FechaMoneda2: Date;
  EsCostoHorario: boolean;
  PendienteAnalizar: boolean;
  ObservacionPendiente: string;
  EsPorcentaje: boolean;
  TipoPorcentaje: number;
  CantidadACopiar?: string;
  Participa: boolean;
  DesdeMaestro?: boolean;
  ArrIdsPartida: [];
  ArrIdsMatriz: [];
  Url: string;
  UrlContenido: string;
  // para el copiado de matriz
  Dividir?: boolean;
  TipoOperacion?: string;
}

export class ClsCatalogosExpIns2 {
  IdCatalogo: bigint;
  IdCodigoSql?: bigint;
  Codigo: string;
  Descripcion: string;
  DescripcionLarga: string;
  EsPorcentaje: number;
  IdFamilia?: bigint;
  Familia: string;
  IdProveedor?: bigint;
  Proveedor: string;
  TipoInsumo: number;
  Unidad: string;
  Referencia: string;
  EsCostoHorario: boolean;
  EsConceptosDelPpto: boolean;
  Expins: number;
  ExpInsl: boolean;
  InsumoIntegrado: boolean;
  Marca: boolean;
  Nivel: number;
  Participa: boolean;
  PendienteAnalizar: boolean;
  ObservacionPendiente: string;
  CostoMoneda1: number;
  FechaMoneda1: Date;
  CostoMoneda2: number;
  FechaMoneda2: Date;
  ArrIdsPartida: [];
  ArrIdsMatriz: [];
  // TipoPorcentaje: number;
  UrlContenido: string;
}

export class ClsExpInsXConceptos {
  IdCatalogo: bigint;
  Tipo: number;
  Codigo: string;
  DescripcionLarga: string;
  Unidad: string;
  Cantidad: number;
  CostoMoneda1: number;
  CostoMoneda2: number;
  ImporteMoneda1: number;
  ImporteMoneda2: number;
  Porcentaje1: number;
  Porcentaje2: number;
}

export class ClsBorrarRegistro {
  IdCatalogo: bigint;
  Codigo: string;
  TieneMatriz: boolean;
  TieneCH: boolean;
  Participa: boolean;
}
